var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        design: "v3",
        "show-footer": false,
        "show-title": false,
        "class-name": "create-invoice-modal-v3",
      },
      on: { cancel: _vm.cancel },
    },
    [
      _c("div", { staticClass: "invoice-modal-content" }, [
        _c("div", { staticClass: "modal-header" }, [
          _c("div", { staticClass: "header-icon" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("receipt_long"),
            ]),
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "header-title" }, [
            _vm._v(_vm._s(_vm.$t("message.createInvoice"))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "header-subtitle" }, [
            _vm._v(_vm._s(_vm.$t("message.fillInvoiceInfo"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "form-container" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c("label", { staticClass: "field-label" }, [
                  _vm._v(_vm._s(_vm.$t("message.invoiceType"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    attrs: {
                      placeholder: _vm.$t("message.selectInvoiceType"),
                      size: "large",
                    },
                    model: {
                      value: _vm.type,
                      callback: function ($$v) {
                        _vm.type = $$v
                      },
                      expression: "type",
                    },
                  },
                  _vm._l(_vm.invoiceTypes, function (option, index) {
                    return _c(
                      "a-select-option",
                      { key: index, attrs: { value: option } },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.formatBillType(option)) +
                            "\n                            "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "div",
                  { staticClass: "price-label-row" },
                  [
                    _c("label", { staticClass: "field-label" }, [
                      _vm._v(_vm._s(_vm.$t("message.amount"))),
                    ]),
                    _vm._v(" "),
                    !_vm.isWalletDeposit
                      ? _c("a-switch", {
                          attrs: {
                            "checked-children": _vm.$t("message.vatIncluded"),
                            "un-checked-children": _vm.$t(
                              "message.vatExcluded"
                            ),
                          },
                          model: {
                            value: _vm.priceTypeSwitch,
                            callback: function ($$v) {
                              _vm.priceTypeSwitch = $$v
                            },
                            expression: "priceTypeSwitch",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("a-input-number", {
                  attrs: {
                    placeholder: "0.00",
                    size: "large",
                    formatter: function (value) {
                      return ("" + value).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    },
                    parser: function (value) {
                      return value.replace(/\$\s?|(,*)/g, "")
                    },
                  },
                  model: {
                    value: _vm.price,
                    callback: function ($$v) {
                      _vm.price = $$v
                    },
                    expression: "price",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "date-fields-group" }, [
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v(_vm._s(_vm.$t("message.creationDate"))),
                  ]),
                  _vm._v(" "),
                  _c("a-date-picker", {
                    attrs: {
                      format: "DD/MM/YYYY",
                      placeholder: _vm.$t("message.selectDate"),
                      size: "large",
                      dropdownClassName: "invoice-date-picker",
                    },
                    model: {
                      value: _vm.createdDate,
                      callback: function ($$v) {
                        _vm.createdDate = $$v
                      },
                      expression: "createdDate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v(_vm._s(_vm.$t("message.dueDateLabel"))),
                  ]),
                  _vm._v(" "),
                  _c("a-date-picker", {
                    attrs: {
                      format: "DD/MM/YYYY",
                      placeholder: _vm.$t("message.selectDate"),
                      size: "large",
                      dropdownClassName: "invoice-date-picker",
                    },
                    model: {
                      value: _vm.dueDate,
                      callback: function ($$v) {
                        _vm.dueDate = $$v
                      },
                      expression: "dueDate",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "a-checkbox",
                  {
                    model: {
                      value: _vm.paid,
                      callback: function ($$v) {
                        _vm.paid = $$v
                      },
                      expression: "paid",
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("message.markAsPaid")))])]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.paid || _vm.paymentDate
              ? _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("label", { staticClass: "field-label" }, [
                      _vm._v(_vm._s(_vm.$t("message.paymentDate"))),
                    ]),
                    _vm._v(" "),
                    _c("a-date-picker", {
                      attrs: {
                        format: "DD/MM/YYYY",
                        placeholder: _vm.$t("message.selectDate"),
                        size: "large",
                        dropdownClassName: "invoice-date-picker",
                      },
                      model: {
                        value: _vm.paymentDate,
                        callback: function ($$v) {
                          _vm.paymentDate = $$v
                        },
                        expression: "paymentDate",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c("label", { staticClass: "field-label" }, [
                  _vm._v("Maksimum Taksit Sayısı"),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    attrs: { size: "large" },
                    model: {
                      value: _vm.installment,
                      callback: function ($$v) {
                        _vm.installment = $$v
                      },
                      expression: "installment",
                    },
                  },
                  [
                    _c("a-select-option", { attrs: { value: 1 } }, [
                      _vm._v("Tek Çekim"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: 2 } }, [
                      _vm._v("2 Taksit"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: 3 } }, [
                      _vm._v("3 Taksit"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: 6 } }, [
                      _vm._v("6 Taksit"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: 9 } }, [
                      _vm._v("9 Taksit"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: 12 } }, [
                      _vm._v("12 Taksit"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c("label", { staticClass: "field-label" }, [
                  _vm._v(_vm._s(_vm.$t("message.description"))),
                ]),
                _vm._v(" "),
                _c("a-textarea", {
                  attrs: {
                    placeholder: _vm.$t(
                      "message.invoiceDescriptionPlaceholder"
                    ),
                    rows: 4,
                    "auto-size": { minRows: 4, maxRows: 6 },
                  },
                  model: {
                    value: _vm.description,
                    callback: function ($$v) {
                      _vm.description = $$v
                    },
                    expression: "description",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.price > 0
            ? _c("div", { staticClass: "price-summary" }, [
                !_vm.isWalletDeposit
                  ? _c("div", { staticClass: "summary-line" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("message.vatExcludedLabel")) + ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.formatPrice(_vm.priceWithoutVat)) + " ₺"
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isWalletDeposit
                  ? _c("div", { staticClass: "summary-line" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("message.vatLabel")) +
                            " (%" +
                            _vm._s(_vm.effectiveVatRate) +
                            "):"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatPrice(_vm.vatAmount)) + " ₺"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isWalletDeposit
                  ? _c("div", { staticClass: "summary-line" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("message.vatLabel")) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("0.00 ₺")]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "summary-line summary-total" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("message.totalLabel")) + ":"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "total-price" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatPrice(
                          _vm.isWalletDeposit ? _vm.price : _vm.priceWithVat
                        )
                      ) + " ₺"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.isWalletDeposit
                  ? _c("div", { staticClass: "summary-note" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("message.vatNotApplicable"))),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-footer" },
          [
            _c(
              "SupsisButton",
              { attrs: { ghost: "" }, on: { click: _vm.cancel } },
              [_vm._v("İptal")]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.create } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("message.createInvoiceButton"))),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }